import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const DeeplinkGenerator = () =>
  import('@/pages/individual-partners/deeplink-management/deeplink-generator/DeeplinkGenerator.vue');

export const deeplinkManagementRoutes: AppRouteRecordRaw[] = [
  {
    path: '/deeplink-management',
    component: Body,
    meta: {
      requiresAuth: true,
      requiredUserGroup: ['freenet'],
      breadcrumb: 'Dashboard',
    },
    children: [
      {
        path: 'deeplink-generator',
        name: 'DeeplinkGenerator',
        component: DeeplinkGenerator,
        meta: {
          title: 'Deeplink Generator | ryd Portal',
          breadcrumb: 'Deeplink Generator',
        },
      },
    ],
  },
];
